import React from "react";
import NaviBar from "../../../Component/Eng_Nav/Navbar";
import Container from "react-bootstrap/Container";
import './Personality.css'
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";

import data from './data.json'; 

function Personality() {
    return (
        <>
            <NaviBar />
            <div className={'personality-bg'}>
                <Container>
                    <div className="image-container">
                        <img src="../../images/image2.png" alt="Profile" className="personality-img" />
                    </div>
                </Container>
                <div className="text-container">
                    <h1 className={"image-top-text"}>Talk About Me</h1>
                    <hr style={{ border: "1px solid #FFF"}}></hr>
                    <h6 className={"image-text"}>The <b>likeness 'Ssook'</b> feeling people around me talk about.</h6>
                </div>
            </div>
            <div className={'personality-bg-white'}>
                <Row className={"cards-row"}>
                    {data.data.map((item, index) => (
                        <Col key={index} md={3} xs={12}>
                            <Card className={"interview-cards"}>
                                <Card.Title style={{fontSize:"2rem"}}>{item.name}</Card.Title>
                                <hr></hr>
                                <Card.Text className={"not-hover-text"} style={{textAlign:"right"}}>{item.company}</Card.Text>
                                <Card.Text className={"not-hover-text keyword-text"} style={{fontSize:"1.5rem", fontWeight:"bold"}}># {item.keyword}</Card.Text>
                                <Card.Text className={"hover-text"}>{item.talk}</Card.Text>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    )
}

export default Personality;
